/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { status } from 'constants/general';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'modules/common/components/Button';
import Popup from 'modules/common/components/Popup';
import ItemWithImageSearchField from 'modules/common/components/ItemWithImageSearchField';
import { fetchBranches, clearBranches } from 'modules/categories/categoriesSlice';
import { getProviders } from 'modules/categories/api';
import { getProvidersList, createQueryParam } from './helper';
import {
  PopupTitleSpan,
  PopupWrapper,
  PopupTitle,
  PopupTitleWrapper,
  Container,
  PopupTitleContainer,
  extendSearchDropDownStyle,
  extendDropDownListItem,
  extendLoaderStyle,
  ButtonsContainer,
  extendBlueButtonStyle,
  ItemsContainer,
  ItemContainer,
  ItemWrapper,
  extendShowMoreButtonStyle,
} from './AddBranchProvidersModal.style';
import ProviderRecord from './ProviderRecord';

const AddBranchProvidersModal = ({
  onClose,
  priceListId,
  bookingTypeId,
  modalStrings,
  providerTypeId,
}) => {
  const dispatch = useDispatch();
  const branches = useSelector(state => state.categories.branches);
  const areas = useSelector(state => state.categories.dropdownsList.areasList);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    statusid: 5,
    searchterm: '',
    PageSize: 10,
    BookingTypeId: bookingTypeId,
    PageNum: 1,
  });
  const [isShowMoreBtnShown, toggleShowMoreBtn] = useState(false);

  useEffect(() => {
    dispatch(fetchBranches(searchQuery));
  }, [searchQuery]);

  useEffect(() => {
    if (branches?.data?.length) {
      // Providers Keys List (BranchKeys)
      const providersKeys = [];
      branches?.data?.forEach(branch => {
        providersKeys.push(branch.BranchKey);
      });

      getProviders(
        `PriceListId=${priceListId}&${createQueryParam('ProviderKeys', providersKeys)}`,
      ).then(reponse => {
        const providersList = getProvidersList(branches?.data, reponse?.data?.data, areas);
        toggleShowMoreBtn(branches?.data?.length === 10);
        setSelectedProviders([...selectedProviders, ...providersList]);
      });
    }
  }, [branches]);

  const searchEntities = keyWord => {
    setSelectedProviders([]);
    setSearchQuery({ ...searchQuery, searchterm: keyWord, PageNum: 1 });
  };

  const onClickShowMore = pageNumber => {
    setSearchQuery({ ...searchQuery, PageNum: pageNumber });
  };

  const onClickClose = () => {
    setSelectedProviders([]);
    onClose();
    dispatch(clearBranches());
  };

  return (
    <Popup showCloseBtn={false}>
      <PopupWrapper>
        <PopupTitleContainer>
          <PopupTitleWrapper>
            <PopupTitle>{modalStrings.title}</PopupTitle>
            <PopupTitleSpan
              onClick={() => {
                onClickClose();
              }}
            />
          </PopupTitleWrapper>
        </PopupTitleContainer>

        <Container>
          <div
            style={{
              height: '85vh',
            }}
          >
            {/** Search */}
            <div
              style={{
                padding: '16px',
                background: '#F1F4F6',
              }}
            >
              <ItemWithImageSearchField
                isRequired
                isDynamic
                isDropDown
                searchable
                key="doctors-search-list"
                componentName="doctors-search-list"
                onTypingDelay={500}
                placeHolder={modalStrings.searchBarPlaceHolder}
                fieldValue=""
                onSearch={keyWord => {
                  searchEntities(keyWord);
                }}
                language="en"
                isLoading={branches.status === status.FETCHING}
                extendLoaderStyle={extendLoaderStyle}
                isValid
                extendDropDownStyle={extendSearchDropDownStyle}
                extendDropDownListItem={extendDropDownListItem}
                icon="e905"
                searchCharacterLimit={0}
              />
            </div>
            {/** Providers section */}
            <div
              style={{
                height: 'calc(85vh - 145px)',
              }}
            >
              {selectedProviders?.length > 0 && (
                <div>
                  <ItemsContainer>
                    <ItemContainer>
                      <ItemWrapper>Providers</ItemWrapper>
                    </ItemContainer>
                    {selectedProviders?.map(item => {
                      const {
                        isSelected,
                        Name,
                        itemImage,
                        BranchKey,
                        AreaKey,
                        providerName,
                        parentEntityKey,
                        isExclusive: exclusive,
                      } = item;
                      return (
                        <ProviderRecord
                          key={BranchKey}
                          branchKey={BranchKey}
                          image={itemImage}
                          name={Name}
                          isSelected={isSelected}
                          areaKey={AreaKey}
                          providerTypeId={providerTypeId}
                          isExclusive={exclusive}
                          priceListId={priceListId}
                          providerName={providerName}
                          parentEntityKey={parentEntityKey}
                        />
                      );
                    })}
                    {isShowMoreBtnShown && (
                      <Button
                        onClick={() => {
                          onClickShowMore(searchQuery.PageNum + 1);
                        }}
                        btnText="Show more"
                        extendButtonStyle={extendShowMoreButtonStyle}
                        key="dismiss-popup"
                        isLoading={branches.status === status.FETCHING}
                        extendLoaderStyle={extendLoaderStyle}
                      />
                    )}
                  </ItemsContainer>
                </div>
              )}
            </div>
            <ButtonsContainer>
              <Button
                onClick={() => {
                  onClickClose();
                }}
                btnText="Close"
                extendButtonStyle={extendBlueButtonStyle}
                key="dismiss-popup"
              />
            </ButtonsContainer>
          </div>
        </Container>
      </PopupWrapper>
    </Popup>
  );
};

AddBranchProvidersModal.propTypes = {
  onClose: PropTypes.func,
  providerTypeId: PropTypes.number,
};

export default AddBranchProvidersModal;
